module.exports = __webpack_public_path__ + "img/spring.510e6aac.png";